import { Constant } from '.'
const downloadBase64File = async (
  base64: string,
  fileName: string,
  extension: string,
) => {
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i))
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: Constant.mimeTypes[extension] })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export default downloadBase64File
